export default __webpack_public_path__ + "static/media/Scrolling.e6260ac4.mp4";